<script lang="ts">
	let { children, style = undefined } = $props();
	import { page } from '$app/state';
	const theme = $derived(page.data.theme);
</script>

<div class={['post-it', theme]} style={'padding: 0.4em;' + style}>
	{@render children()}
</div>
